import { Checkbox, styled, TextField, Typography, FormControlLabel } from '@mui/material';
import { List, ListItem } from '../../../components/List';
import { formationWithoutOptionsMapping } from '../../constants';
import { formationsWithoutOptionsSummaryType, formationWithoutOptionSlugType } from '../../types';

function FormationWithoutOptions(props: {
    slug: formationWithoutOptionSlugType;
    formationsWithoutOptionsSummary: formationsWithoutOptionsSummaryType;
    setFormationsWithoutOptionsSummary: (
        formationsWithoutOptionsSummary: formationsWithoutOptionsSummaryType,
    ) => void;
}) {
    const selectedDate = props.formationsWithoutOptionsSummary[props.slug].date;
    const isSelected = props.formationsWithoutOptionsSummary[props.slug].isSelected;
    const formationInfo = formationWithoutOptionsMapping[props.slug];
    return (
        <Container>
            <Title variant="h4">{formationInfo.title}</Title>
            <List>
                <ListItem>
                    <FormControlLabel
                        control={<Checkbox checked={isSelected} />}
                        onChange={(_, checked) => setIsSelected(checked)}
                        label="Date souhaitée :"
                    />
                    <TextField
                        required={isSelected}
                        disabled={!isSelected}
                        type="date"
                        value={selectedDate || ''}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        placeholder="JJ/MM/AAAA"
                        variant="standard"
                    />
                </ListItem>
            </List>
        </Container>
    );

    function setSelectedDate(date: string) {
        props.setFormationsWithoutOptionsSummary({
            ...props.formationsWithoutOptionsSummary,
            [props.slug]: {
                ...props.formationsWithoutOptionsSummary[props.slug],
                date,
            },
        });
    }

    function setIsSelected(isSelected: boolean) {
        props.setFormationsWithoutOptionsSummary({
            ...props.formationsWithoutOptionsSummary,
            [props.slug]: {
                ...props.formationsWithoutOptionsSummary[props.slug],
                isSelected,
                date: '',
            },
        });
    }
}

const Container = styled('div')(({ theme }) => ({}));
const Title = styled(Typography)(({ theme }) => ({}));

export { FormationWithoutOptions };
